export { default } from './PartnersProgramsSlider';
